module.exports = __webpack_public_path__ + "img/full5-min.48fcc4a1.png";